import React from 'react';
import { useContext } from 'react';
import { AuthContext } from '../../../common/authContext';
import Header from '../../User/Header';
import HeaderContainer from '../../../containers/User/HeaderContainer';
import Container from '../../Common/Container';
import Grid from '../../Common/Grid';
import { Box, Button, Card, CardContent, Typography } from '@material-ui/core';
import useStyles from './styles';
import image from './realtorHome.png';
import { FormattedMessage } from 'react-intl';
import messages from './messages';
import { useHistory } from 'react-router-dom';
import { colors } from '../../../common/theme';
import ReactPlayer from 'react-player';

const CARDS_DATA = [
  {
    title: 'What is RealGenius.io',
    description:
      'A Real Estate Agent’s Real Estate Transaction Command Center. Managing clients from “Potential” to “Closed”. Simple, but powerful tool to work with Buyers, Sellers, and the agents Lender and Title Company partners to exceed client expectations.',
    videoUrl: 'https://youtu.be/_sKURGS_f2g?cc_load_policy=0'
  },
  {
    title: 'Buyer Basics with RealGenius.io',
    description:
      'In this video we address “Realistic” Buyer Pre-Qualification – Price, Payment, and Funds to Close. Unlike “Lender” Prequalification’s with limited to no value, Buyers “Prequalifies” themselves for the transaction.',
    videoUrl: 'https://youtu.be/TpwYtYwmvfc?cc_load_policy=0'
  },
  {
    title: 'Learn to List',
    description:
      'Listing a property in today’s Real Estate Market should be about educating the client as to Market Conditions, and how these are used in establishing an Initial List Price.  Sellers are most interested in Net Proceeds, and how long it will take to close on a Sale, but there are many factors to consider.  The Learn to List video walks through the process to professionally educate potential Sellers, thereby increasing the opportunity to gain more Listings.',
    videoUrl: 'https://youtu.be/guiAjKBZHuY?cc_load_policy=0'
  },
  {
    title: 'Time is Money – Buyer/Seller Demos',
    description:
      'Get a preview of one of the RealGenius.io sales training sessions, Selling in 30-Second Timelines. In this video, Rick demonstrates proven techniques for engaging both buyers and sellers, showing you how to communicate your value quickly, build confidence, and create meaningful conversations that lead to more opportunities.',
    videoUrl: 'https://youtu.be/hWfoWRrIvbs?cc_load_policy=0'
  }
];

export default function RealtorHomeScreen() {
  const classes = useStyles();
  const history = useHistory();
  const { authUser } = useContext(AuthContext);

  const handleStartNow = () =>
    history.push(authUser ? '/welcome' : '/realtor-sign-up');
  const handleLearnMore = () => {
    const element = document.getElementById('videos-section');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };
  const handleLogin = () => history.push('/sign-in');

  const cards = () => {
    return CARDS_DATA.map((card, index) => (
      <Grid item xs={12} md={6} key={index}>
        <Card style={{ height: '100%' }}>
          <CardContent>
            <Box mt={2} width="100%" className={classes.videoWrapper}>
              <ReactPlayer
                width="100%"
                height="100%"
                src={card.videoUrl}
                controls={true}
                config={{ youtube: { cc_load_policy: 0 } }}
              />
            </Box>
            <Box mt={4} mb={2}>
              <Typography variant="h5">{card.title}</Typography>
              <Typography variant="body1">{card.description}</Typography>
            </Box>
          </CardContent>
        </Card>
      </Grid>
    ));
  };

  return (
    <>
      {authUser?._id ? <HeaderContainer /> : <Header />}
      <Container maxWidth="xl" component="div" disableGutters>
        <Grid container justifyContent="center" className={classes.root}>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            pt={{ xs: 4, sm: 8 }}
            pb={{ xs: 5, sm: 10 }}
            px={{ xs: 8, sm: 17 }}
          >
            <Box display="flex" flexDirection="column" mr={{ xs: 0, sm: 12.5 }}>
              <Box pb={1.5}>
                <Typography variant="h3">
                  <FormattedMessage {...messages.welcomeTo} />
                </Typography>
              </Box>
              <Box pb={1.5}>
                <Typography variant="h3" color="primary">
                  <FormattedMessage {...messages.realGeniusRealtor} />
                </Typography>
              </Box>
              <Box className={classes.textContainer}>
                <Typography variant="h6">
                  <FormattedMessage
                    {...messages.realGeniusRealtorDescription}
                  />
                </Typography>
              </Box>
              <Box className={classes.buttonsContainer}>
                <Button
                  variant="contained"
                  color="secondary"
                  size="large"
                  onClick={handleLearnMore}
                >
                  <FormattedMessage {...messages.learnMoreButton} />
                  <br />
                  <FormattedMessage {...messages.clickHere} />
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  onClick={handleStartNow}
                >
                  {authUser ? (
                    <FormattedMessage {...messages.welcomeButton} />
                  ) : (
                    <FormattedMessage {...messages.signUpButton} />
                  )}
                </Button>
                {!authUser && (
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    onClick={handleLogin}
                  >
                    <FormattedMessage {...messages.loginButton} />
                  </Button>
                )}
              </Box>
            </Box>
            <img src={image} alt="background" className={classes.image} />
          </Box>
          <Box
            bgcolor={colors.primary}
            width="100%"
            display="flex"
            py={{ xs: 3, sm: 5.5 }}
            alignItems="center"
            justifyContent="center"
          >
            <Box width={{ xs: '80%', md: '50%' }} textAlign="center">
              <Typography
                variant="h6"
                color="textPrimary"
                className={classes.highlightContentText}
              >
                <FormattedMessage {...messages.highlightContent} />
              </Typography>
            </Box>
          </Box>
          <Grid
            id="videos-section"
            container
            justifyContent="center"
            spacing={2}
            className={classes.cardsContainer}
          >
            {cards()}
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
